(() => {
  'use strict';
  const states = new WeakMap();
  const headerPanels = '.mnd-ed-shop-nav, .mnd-ed-tools>details';
  const groups = node => Array.from(node.querySelectorAll('variant-selects [data-mnd-option-index]'));
  const eligible = node => node?.classList.contains('mnd-atelier');
  const getInputs = group => Array.from(group.querySelectorAll('input[type="radio"]'));
  const complete = node => {
    if (!eligible(node) || !node.querySelector('variant-selects')) return true;
    const state = states.get(node);
    return !!state && groups(node).every(group => Object.hasOwn(state.choices, group.dataset.mndOptionIndex));
  };
  const restore = node => {
    if (!eligible(node)) return;
    const state = states.get(node);
    if (!state) return;
    groups(node).forEach(group => {
      if (group.hasAttribute('data-mnd-single-value')) {
        state.choices[group.dataset.mndOptionIndex] = group.dataset.mndSingleValue;
      }
      const selected = state.choices[group.dataset.mndOptionIndex];
      getInputs(group).forEach(input => { input.checked = selected === input.value; });
      const select = group.querySelector('select');
      if (select) { select.selectedIndex = -1; if (selected !== undefined) select.value = selected; }
      const label = group.querySelector('[data-selected-value]');
      if (label) label.textContent = selected ?? '';
    });
    const sku = node.querySelector('[id^="Sku-"]');if(sku)sku.hidden=!complete(node);
    const hint = node.querySelector('[data-mnd-selection-hint]');
    if (hint) hint.textContent = complete(node) ? '' : window.mndEditorialStrings.chooseOptions;
  };
  window.MndEditorial = {
    initProduct(node) {
      if (!eligible(node) || states.has(node)) return;
      states.set(node, {choices:{}});
      restore(node);
      const button = node.querySelector('[name="add"]');
      if (!complete(node)) button?.setAttribute('disabled', '');
      else if (groups(node).length && groups(node).every(group => group.hasAttribute('data-mnd-single-value')) && button?.dataset.mndAvailable === 'true') button.removeAttribute('disabled');
    },
    selectOption(node, target) {
      if (!eligible(node)) return true;
      this.initProduct(node);
      const group = target.closest('[data-mnd-option-index]');
      if (group) states.get(node).choices[group.dataset.mndOptionIndex] = target.value;
      restore(node);
      return complete(node);
    },
    restoreOptions: restore,
    canSubmit: complete
  };
  function init(root = document) {
    root.querySelectorAll('[data-mnd-story-close]').forEach(button => {
      if (button.dataset.bound) return;
      button.dataset.bound = 'true';
      button.hidden = false;
      button.addEventListener('click', () => {
        const story = button.closest('[data-mnd-story]');
        story.open = false;
        story.querySelector('summary').focus();
      });
    });
    const policy=root.querySelector('.shopify-policy__body');
    if(policy && !policy.dataset.mndIndexed){
      policy.dataset.mndIndexed='true';
      const headings=Array.from(policy.querySelectorAll('h2,h3'));
      if(headings.length>1){
        const nav=document.createElement('nav'); nav.className='mnd-ed-policy-toc'; nav.setAttribute('aria-label','On this page');
        headings.forEach((heading,index)=>{if(!heading.id)heading.id='mnd-policy-'+index;const link=document.createElement('a');link.href='#'+heading.id;link.textContent=heading.textContent;nav.append(link);});
        const index=document.createElement('details');index.className='mnd-ed-policy-index';const summary=document.createElement('summary');summary.textContent='On this page';index.append(summary,nav);policy.before(index);
      }
    }

    root.querySelectorAll('product-info.mnd-atelier').forEach(node => window.MndEditorial.initProduct(node));
    root.querySelectorAll('[data-mnd-faq-search]').forEach(input => {
      if (input.dataset.bound) return;
      input.dataset.bound='true';
      input.addEventListener('input', () => {
        const scope = input.closest('[data-mnd-faq]');
        const query = input.value.trim().toLocaleLowerCase();
        let count=0;
        scope.querySelectorAll('[data-mnd-faq-item]').forEach(item => {
          const matched=item.textContent.toLocaleLowerCase().includes(query);
          item.hidden=!matched;
          if (matched) { count++; if(query) item.open=true; }
          else item.open=false;
        });
        scope.querySelectorAll('.mnd-ed-faq-group').forEach(group=>{group.hidden=![...group.querySelectorAll('[data-mnd-faq-item]')].some(item=>!item.hidden);});
        scope.querySelector('[data-mnd-faq-empty]').hidden=count>0;
      });
    });
    root.querySelectorAll('[data-mnd-care-select]').forEach(select => {
      if (select.dataset.bound) return;
      select.dataset.bound='true';
      select.addEventListener('change', () => {
        const section=select.closest('[data-mnd-care]');
        section.querySelectorAll('details').forEach(item => { item.open=item.id===select.value; });
        if(select.value) document.getElementById(select.value)?.scrollIntoView({block:'nearest',behavior:'auto'});
      });
    });
    root.querySelectorAll('[data-mnd-copy-url]').forEach(button => {
      if(button.dataset.bound)return;
      button.dataset.bound='true';
      button.addEventListener('click',async()=>{
        const status=button.parentElement.querySelector('[data-mnd-copy-status]');
        try { await navigator.clipboard.writeText(location.href);status.textContent=window.mndEditorialStrings.copied; }
        catch { status.textContent=location.href; }
      });
    });
    root.querySelectorAll(headerPanels).forEach(details => {
      if(details.dataset.bound)return;
      details.dataset.bound='true';
      details.addEventListener('toggle',()=>{
        if(details.open){root.querySelectorAll(headerPanels).forEach(other=>{if(other!==details)other.open=false;});(details.querySelector('input')||details.querySelector('nav a'))?.focus();}
      });
    });
  }
  document.addEventListener('keydown',event=>{
    if (event.key === 'Escape') {
      const story = event.target.closest('[data-mnd-story][open]');
      if (story) { story.open = false; story.querySelector('summary').focus(); }
    }
    if(event.key==='Escape')document.querySelectorAll('.mnd-ed-shop-nav[open], .mnd-ed-tools>details[open]').forEach(details=>{details.open=false;details.querySelector('summary').focus();});
  });
  document.addEventListener('click',event=>{
    document.querySelectorAll('.mnd-ed-shop-nav[open], .mnd-ed-tools>details[open]').forEach(details=>{
      if (!details.contains(event.target)) details.open=false;
    });
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',event=>init(event.target));
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, event => {
      const bag = document.getElementById('cart-icon-bubble');
      if (bag && Number.isFinite(event.cartData?.item_count)) {
        const label = bag.getAttribute('aria-label') || 'Bag';
        bag.setAttribute('aria-label', label.replace(/\s*\(\d+\)$/, '') + ' (' + event.cartData.item_count + ')');
      }
    });
  }
})();

